import React, { useState, useEffect, useMemo } from "react";
import { i18n } from "@src/utils/i18n";
import { message } from "@cloud/atom-ui";
import { setScope, cancelAuth } from "./thunk";
import * as nls from "./nls";
import * as css from "./style.module.less";
import webConfig from "@src/configs/web.config";
import { GetStatusThunk_in } from "./thunk";
const I18N = i18n(nls);
const text = I18N;
import { Modal } from "@cloud/atom-ui";
import { getAppPathFromType, APP_TYPE } from "@src/utils/common";

//权限列表
export default props => {
  const spaces = [1, 2.6, 1, 1]; //宽度比例
  const {
    tenantInfo,
    item,
    canEdit,
    appId,
    partId,
    type,
    scopeList,
    eventCallBackUrl,
    updateScopeList,
    setTipModalVisible,
    onPermissionCancel,
    onChangeOperation
  } = props;
  const [title, setTitle] = useState(item.subLable || "");
  const [chartTitle, setChartTitle] = useState("");
  const [child, setChild] = useState(item.list || []);
  const [callBackUrl, setCallBackUrl] = useState(eventCallBackUrl || "");

  useEffect(() => {
    if (item) {
      const title = item.subLable || "";
      setTitle(title);
      const cTitle =
        title && /^[a-zA-Z]+$/.test(title.charAt(0))
          ? title.replace(title.charAt(0), "")
          : title;
      setChartTitle(cTitle);
      item.list && setChild(item.list);
    }
  }, [item]);

  useEffect(() => {
    setCallBackUrl(eventCallBackUrl);
  }, [eventCallBackUrl]);

  const actionsConfig = {
    applyAuth: {
      name: text.applyAuth,
      color: "#689BF0",
      operation: (auth, index) => {
        setAuth(auth, 0, partId, index);
      }
    },
    disableAuth: {
      name: text.cancelAuth,
      color: "#FF8870",
      operation: (auth, index) => {
        setAuth(auth, 1, partId, index);
      }
    },
    showUrl: {
      name: "请先设置回调地址"
    }
  }; // 取消、开通

  const authConfig = {
    unApply: {
      name: text.notOpen,
      color: "#689BF0"
    },
    apply: {
      name: text.opened,
      color: "#595959"
    },
    approving: {
      name: text.approving,
      color: "#689BF0"
    },
    reject: {
      name: text.reject,
      color: "#FF8870"
    }
  }; //权限对应

  //申请、取消授权
  const setAuth = async (auth, status, partId, index) => {
    const reqAuth = status === 1 ? cancelAuth : setScope;
    const res = await reqAuth(appId, auth.id, getAppPathFromType(type));
    if (res && res.status == 1) {
      let list = scopeList;
      list[partId].list[index].authStatus = status == "1" ? "0" : "1";
      updateScopeList && updateScopeList(list);
    } else {
      if (res && res.status === 403) {
        message.error(
          <>
            {" "}
            无法申请该API权限，请联系管理员。
            <a
              onClick={() =>
                window.open(webConfig.developerPermission, "_blank")
              }
            >
              了解更多
            </a>
          </>
        );
      } else {
        message.error(<> {res["errMsg"]}</>);
      }
    }
  };

  //设置权限列表展示和隐藏
  const canAuthList = (canEdit, item, index) => {
    if (item.scopeType != 2) {
      let param =
        item.authStatus == 0
          ? actionsConfig["applyAuth"]
          : item.authStatus == 1
          ? actionsConfig["disableAuth"]
          : {};
      return canEdit ? renderRowItem(false, 3, param, item, index) : null;
    } else {
      if (canEdit) {
        if (callBackUrl != "") {
          let param =
            item.authStatus == 0
              ? actionsConfig["applyAuth"]
              : item.authStatus == 1
              ? actionsConfig["disableAuth"]
              : {};
          return renderRowItem(false, 3, param, item, index);
        } else {
          let param =
            item.authStatus == 0
              ? actionsConfig["showUrl"]
              : item.authStatus == 1
              ? actionsConfig["disableAuth"]
              : {};
          return renderRowItem(false, 3, param, item, index);
        }
      }
      return null;
    }
  };

  const permissionCancelNotify = async (params, item, index) => {
    try {
      let appType =
        type == APP_TYPE.innerapp || type == 3
          ? 7
          : type == APP_TYPE.isv || type == 4
          ? 8
          : 9;
      const res = await GetStatusThunk_in(appId, appType);
      const { isPublish } = res;
      if (isPublish === 1) {
        onPermissionCancel();
        onChangeOperation(params, item, index);
      } else {
        params.operation(item, index);
      }
    } catch (error) {
      console.log("error ===", error);
      message.error("取消权限通知失败");
    }
  };

  const closeLockInfo = () => {
    Modal.info({
      title: "请联系管理员授权此权限"
    });
  };

  const unlockInfo = () => {
    Modal.info({
      title: "管理员已同意该接口授权，可正常申请本API授权"
    });
  };

  const handleOperation = (item, params, index, showTips, showLock) => {
    // 如果没有实名认证并且没有授权显示弹窗，如果实名认证了但已授权，是可以取消授权的
    if (
      item.ifRealNameAuth &&
      item.authStatus === "0" &&
      item.permissionStatus !== 1 &&
      showTips
    ) {
      setTipModalVisible(true);
    } else if (
      (item.permissionStatus === 1 && showTips && params.name === "申请授权") ||
      (item.permissionStatus === 1 && item.authStatus === "0")
    ) {
      closeLockInfo();
    } else if (
      !item.ifRealNameAuth &&
      item.permissionStatus === 2 &&
      item.authStatus === "0" &&
      showTips &&
      showLock
    ) {
      unlockInfo();
    } else {
      if (params.name === "取消授权") {
        permissionCancelNotify(params, item, index);
      } else {
        if (params.operation) {
          params.operation(item, index);
        }
      }
    }
  };

  /**
   * 创造单元格数据
   * @param { 类型，true文字，false其他 } isText
   * @param {*表格第几列} column
   * @param {actionsConfig中定义的配套参数} params
   * @param {数据} item
   * @param {在数组中的序号} index
   * @returns
   */

  const isShowLock = (item, params, index) => {
    if (item.ifRealNameAuth && item.permissionStatus !== 1) {
      return (
        <span
          className={
            tenantInfo.realNameAuth ? css["icon-unlock"] : css["icon-lock"]
          }
          onClick={() => handleOperation(item, params, index, true, true)}
        />
      );
    }
    if (item.permissionStatus && params.operation) {
      return (
        <span
          className={
            item.permissionStatus === 1 ? css["icon-lock"] : css["icon-unlock"]
          }
          onClick={() => handleOperation(item, params, index, true, true)}
        />
      );
    }
  };
  const renderRowItem = (isText, column, params, item, index) => {
    if (isText) {
      return (
        <div
          key={column}
          style={{ flex: `${spaces[column]}` }}
          className={css["wecode-list-item"]}
        >
          <span title={params}>{params}</span>
        </div>
      );
    } else {
      return (
        <div
          key={column}
          style={{ flex: `${spaces[column]}` }}
          className={`${css["wecode-list-item"]} ${css["padl22"]}`}
        >
          {tenantInfo && column === 3 && isShowLock(item, params, index)}
          {tenantInfo && params.operation ? (
            <span
              style={{ cursor: "pointer", color: params.color }}
              onClick={() =>
                handleOperation(
                  item,
                  params,
                  index,
                  !tenantInfo.realNameAuth,
                  false
                )
              }
            >
              {params.name}
            </span>
          ) : (
            <span style={{ color: params.color }}> {params.name} </span>
          )}
        </div>
      );
    }
  };

  const getColumn2param = item => {
    if (item.authStatus == 0) {
      return authConfig["unApply"];
    } else if (item.authStatus == 1) {
      return authConfig["apply"];
    } else if (item.authStatus == 2) {
      return authConfig["approving"];
    } else if (item.authStatus == 3) {
      return authConfig["reject"];
    } else {
      return {};
    }
  };

  return (
    <div key={title} className={css["chart"]}>
      <div className={css["chart-title"]}>{chartTitle}</div>
      <div className={css["wecode-list"]}>
        <div className={`${css["wecode-list-header"]} ${css["bottom-line"]}`}>
          <div style={{ flex: `${spaces[0]}` }} key="0">
            权限名称
          </div>
          <div style={{ flex: `${spaces[1]}` }} key="1">
            权限描述
          </div>
          <div style={{ flex: `${spaces[2]}`, paddingLeft: "22px" }} key="2">
            状态
          </div>
          {canEdit && (
            <div style={{ flex: `${spaces[3]}`, paddingLeft: "22px" }} key="3">
              操作
            </div>
          )}
        </div>
        <div className={css["wecode-list-body"]}>
          {child &&
            child.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`${css["wecode-list-item"]} ${css["bottom-line"]}`}
                >
                  {renderRowItem(true, 0, item["scopeName"], item, index)}
                  {renderRowItem(true, 1, item["scopeDesc"], item, index)}
                  {renderRowItem(false, 2, getColumn2param(item), item, index)}
                  {canAuthList(canEdit, item, index)}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};
